import { useQuery } from '@tanstack/react-query'
import { useApi } from '../../lib/useApi'
import { useT } from '../../lib/i18n.js'

const TABS = [
  { id: 'heute', icon: '◆' },
  { id: 'board', icon: '▦' },
  { id: 'daten', icon: '⛁' },
  { id: 'mehr',  icon: '•••' },
]

export default function BottomTabBar({ tab, setTab }) {
  const api = useApi()
  const { data: profile } = useQuery({ queryKey: ['profile'], queryFn: () => api.get('/profile') })
  const t = useT(profile?.locale)
  return (
    <nav role="navigation" aria-label="Primary"
         className="md:hidden fixed left-0 right-0 bottom-0 border-t border-card grid grid-cols-4 z-30"
         style={{ background: 'color-mix(in srgb, var(--bg) 90%, transparent)' }}>
      {TABS.map((it) => (
        <button key={it.id}
                aria-label={t(`nav.${it.id}`)}
                aria-current={tab === it.id ? 'page' : undefined}
                onClick={() => setTab(it.id)}
                className={`tap py-2 flex flex-col items-center text-[10px] tracking-widest uppercase ${
                  tab === it.id ? 'text-accent' : 'opacity-60'
                }`}>
          <span aria-hidden="true" className="text-base">{it.icon}</span>
          {t(`nav.${it.id}`)}
        </button>
      ))}
    </nav>
  )
}
